import { isBootFeatureEnabled } from 'owa-metatags';

const useLocalUtils = isBootFeatureEnabled('fwk-owa-lodash-local-utils');

export function flighted<T extends (...args: any[]) => any>(
    localImplementation: T,
    lodashImplementation: (...args: any[]) => any
): T {
    return function (this: ThisParameterType<T>, ...args: Parameters<T>): ReturnType<T> {
        const implementation = useLocalUtils ? localImplementation : lodashImplementation;
        return implementation.apply(this, args);
    } as T;
}
